import {AnyAction, Dispatch} from "@reduxjs/toolkit";
import axios from "axios";
import {previewStatusUrl} from "./url";
import {setPreviewDataFromBackend} from "../store/makerDataSlice";
import * as Sentry from "@sentry/react";
import getPreviewData from "./getPreviewData";

export let canGetPreviewStatus = {
    value: true
};

export const THEMES_FULL_PREVIEW = [
    'vk13',
    'vk17',
    'vk19',
    'vk33',
    'vk35',
    'vk37',
    'vk38'
];

const getTimeout = {
    id: null,
};

export default async function getPreviewStatus(previewId: string|null, dispatch: Dispatch<AnyAction>, i: number) {
    try {
        if (previewId === null || typeof previewId === 'undefined') {
            return;
        }

        // если передан через GET previewId - не отправляем email'ы об окончании создания preview
        const urlParams = new URLSearchParams(window.location.search);
        const params = {
            i: i,
            se: urlParams.has('previewId') ? 0 : 1
        };

        const response = await axios.get(previewStatusUrl + previewId, {params: params});
        if (response.data.result == 'ok') {
            // @ts-ignore
            Sentry.getClient()?.getIntegrationByName("Replay")?.flush();
            if (response.data.previewId === previewId) {
                const previewData = response.data;
                dispatch(setPreviewDataFromBackend(previewData));

                let waitTimeout = i < 10 ? 2000 : 5000;

                if (previewData?.mainVideo?.isReady !== true && canGetPreviewStatus.value) {
                    if (getTimeout.id !== null) clearTimeout(getTimeout.id);
                    // @ts-ignore
                    getTimeout.id = setTimeout(() => {
                            getPreviewStatus(previewId, dispatch, previewData?.i);
                    }, waitTimeout);
                }
            }
        } else if (response.data.result === 'not_found') {
            // может быть not_found если ещё не начался рендеринг и jobb'а ещё не создана
            if (canGetPreviewStatus.value) {
                if (getTimeout.id !== null) clearTimeout(getTimeout.id);
                // @ts-ignore
                getTimeout.id = setTimeout(() => {
                    getPreviewStatus(previewId, dispatch, response.data?.i);
                }, 1000);
            }
        } else {
            Sentry.captureException(
                new Error('Failed to get preview data.'),
                {
                    extra: {
                        response: response,
                        responseConfig: JSON.stringify(response?.config),
                        responseData: JSON.stringify(response?.data),
                        url: previewStatusUrl + previewId
                    }
                }
            )
        }
    } catch (err) {
        Sentry.captureException(
            new Error('Failed to load preview status. Error.'),
            {
                extra: {
                    url: previewStatusUrl + previewId,
                    error: err,
                    responseConfig: axios.isAxiosError(err) ? JSON.stringify(err.response?.config) : '',
                    responseData: axios.isAxiosError(err) ? JSON.stringify(err.response?.data) : ''
                }
            }
        )
    }
}